import { useMemo } from "react";

import { queryGetProgressGenerateAIJobSuggestion } from "@type/api/businessUnit";
import { useAIProgressStore, useBusinessUnitStore } from "@type/store";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { TGetProgressGenerateAIJobSuggestionRes } from "@type/api/businessUnit/types";

interface UseGetProgressGenerateAIJobSuggestionProps {
  onSuccess?: (res: TGetProgressGenerateAIJobSuggestionRes) => void;
}

export const useGetProgressGenerateAIJobSuggestion = ({
  onSuccess,
}: UseGetProgressGenerateAIJobSuggestionProps) => {
  const selectedBU = useBusinessUnitStore((state) => state.selectedBU);
  const isInProgress = useAIProgressStore((state) => state.isInProgress);
  const refetchInterval = useAIProgressStore((state) => state.refetchInterval);

  const queryGetProgressGenerateAIJobSuggestionKey = useMemo(() => {
    return queryGetProgressGenerateAIJobSuggestion._key({
      idBu: selectedBU?.idUnique || "",
      data: {
        idBu: selectedBU?.idUnique || "",
      },
    });
  }, [selectedBU]);

  const { data, isLoading: isLoadingGetProgressGenerateAIJobSuggestion } =
    useQueryWithCallbacks({
      queryKey: queryGetProgressGenerateAIJobSuggestionKey,
      enabled: !!selectedBU?.idUnique && isInProgress,
      refetchInterval: refetchInterval,
      queryFn: () =>
        queryGetProgressGenerateAIJobSuggestion({
          idBu: selectedBU?.idUnique || "",
          data: {
            idBu: selectedBU?.idUnique || "",
          },
        }),
      onSuccess: onSuccess,
    });

  return {
    isLoadingGetProgressGenerateAIJobSuggestion,
    progressGenerateAIJobSuggestion: data,
    queryGetProgressGenerateAIJobSuggestionKey,
  };
};
